import { Flex, Text, useMantineTheme } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { client_selected } from "../../../../client";

type IProps = {
  value?: string;
  label: string;
  color?: string;
};

export default function InfoTrade({ value = "----", label, color }: IProps) {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const isSpider =
    client_selected.name === "SpiderCrypto" ||
    client_selected.name === "SpiderTrader";
  return (
    <Flex direction={"column"} align={"center"} justify={"center"}>
      <Text
        fw={600}
        size={12}
        lh="19px"
        color={
          color
            ? color
            : isSpider
            ? theme.colors.basic[0]
            : theme.colors.basic[0]
        }
        h="19px"
      >
        {value}
      </Text>
      <Text
        fw={500}
        size={12}
        lh="19px"
        color={isSpider ? theme.colors.basic[0] : theme.colors.basic[0]}
        h="19px"
      >
        {t(label)}
      </Text>
    </Flex>
  );
}
